import {
  migrateCWFTableChildMappings,
  migrateToAppJSON,
  migrateToNewECAProcess,
  reverseMigrateIntegrationFieldsFromNewFormat
} from "../utils/migrations/processMigrations.helper";

export const migrations = [
  {
    id: "v1",
    name: "migrateCWFTableChildMappings",
    desc: "Migrate Old Format of Child Mappings of L0 table to new format",
    callback: migrateCWFTableChildMappings
  },
  // v2.4 is same as v2.1 that's why this is commented out
  // to make sure we don't run same migration twice
  // {
  //   id: "v2.1", // migration to add ECA Rules Sequence to Process is V2. V2.1 added because V2 was reverted earlier and in current PR we are adding it back.
  //   name: "addingECARulesSequenceToProcess",
  //   desc: "Adding ECA Rules Sequence to Process",
  //   callback: migrateToNewECAProcess
  // },
  {
    id: "v2.3",
    name: "reverseMigrateIntegrationFieldsFromNewFormat",
    desc: "Reverse Migrate Integration Fields from New Format to Original Format",
    callback: reverseMigrateIntegrationFieldsFromNewFormat
  },
  {
    // v2.5 is same as v2.4.
    // We need to run same migration because after v2.4 we added the replaceAllEventRules and replaceAllStateRules
    // in that we have incorrect logic which leads to incorrect event/state sequence in process.
    id: "v2.5",
    name: "regenerateECARuleSequence",
    desc: "Regenerate ECA Rule Sequence",
    callback: migrateToNewECAProcess
  },
  {
    id: "v3",
    name: "migrateToAppJSON",
    desc: "Migrate to App JSON",
    callback: migrateToAppJSON
  }
] as const;
